import { continueFromInstallGuide, retryPreload, skipPreload } from "../../app/actions.ts";
import { useApp } from "../../app/store.ts";
import { vi } from "../../i18n/vi.ts";
import { Art, Button } from "../components/common.tsx";

/** The share glyph Safari shows in its toolbar, so players can spot it. */
function ShareGlyph() {
  return (
    <svg className="install__glyph" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3v12M7.5 7.5 12 3l4.5 4.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 10H6.5A1.5 1.5 0 0 0 5 11.5v8A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5v-8a1.5 1.5 0 0 0-1.5-1.5H16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

/** iPhone/iPad in Safari: suggest installing to the home screen before playing. */
export function InstallGuide() {
  return (
    <div className="install" data-testid="install-guide">
      <Art id="logo.main" className="install__logo" alt="NANO Magical City" />
      <div className="install__card">
        <h1 className="install__title">
          <Art id="icon.add-home" className="install__title-icon" />
          {vi.install.title}
        </h1>
        <p>{vi.install.body}</p>
        <ol className="steps">
          <li>
            <span>
              {vi.install.step1} <ShareGlyph />
            </span>
          </li>
          <li>
            <span>{vi.install.step2}</span>
          </li>
          <li>
            <span>{vi.install.step3}</span>
          </li>
        </ol>
        <p className="note">{vi.install.note}</p>
        <Button variant="secondary" onClick={() => continueFromInstallGuide()} testId="install-continue">
          {vi.install.continue}
        </Button>
      </div>
      <p className="credit">{vi.credit}</p>
    </div>
  );
}

/** Downloads every asset before play so iOS never stalls mid-level. */
export function Preloader() {
  const preload = useApp((s) => s.ui.preload);
  if (!preload) return null;
  const pct = preload.total > 0 ? Math.round((preload.done / preload.total) * 100) : 0;
  return (
    <div className="splash" data-testid="preloader">
      <Art id="logo.main" className="splash__logo" alt="NANO Magical City" />
      <h2 className="preload__title">{vi.preload.title}</h2>
      <div className="splash__bar" role="progressbar" aria-valuenow={pct}>
        <span style={{ width: `${Math.max(4, pct)}%` }} />
      </div>
      <p className="splash__text">
        {vi.preload.progress(preload.done, preload.total)}
      </p>
      <p className="note preload__body">{vi.preload.body}</p>
      {preload.failed ? (
        <div className="preload__actions">
          <p className="note">{vi.preload.failed}</p>
          <Button onClick={() => retryPreload()}>{vi.preload.retry}</Button>
          <Button variant="ghost" onClick={() => skipPreload()}>
            {vi.preload.skip}
          </Button>
        </div>
      ) : null}
      <p className="credit">{vi.credit}</p>
    </div>
  );
}
